module.exports = __webpack_public_path__ + "static/reactcomponents-261588637232cfc94214e210027b0c05.png";